import { useQuery } from "react-query";
import api from "../api";
import { API_ROUTES } from "../../utils/const";

const FETCH_VIRTUAL_ACCOUNT_TRANSACTIONS = async (data) => {
  const response = await api.post(
    API_ROUTES.GET_VIRTUAL_ACCOUNT_TRANSACTIONS,
    data,
  );
  return response.data;
};

export const getVirtualAccountTransactionsData = (data) => {
  return useQuery({
    queryKey: ["virtualAccountTransactions", data],
    queryFn: () => FETCH_VIRTUAL_ACCOUNT_TRANSACTIONS(data),
    enabled: !!data.business,
  });
};
